import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgContactKlantenservice = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#0061CD"
      d="M20 33c7.18 0 13-5.82 13-13S27.18 7 20 7 7 12.82 7 20s5.82 13 13 13"
    />
    <path
      fill="#00215B"
      d="M18 33c-7.18 0-13-5.82-13-13S10.82 7 18 7s13 5.82 13 13h1c0-7.73-6.27-14-14-14S4 12.27 4 20s6.27 14 14 14z"
    />
    <path
      fill="#fff"
      d="M18.45 17.56h3.1V28h-3.1zm1.55-1.6c-.57 0-1.04-.19-1.42-.57s-.58-.85-.58-1.41.19-1.03.58-1.41c.38-.38.86-.57 1.42-.57s1.04.19 1.42.57.58.85.58 1.41-.19 1.03-.58 1.41-.86.57-1.42.57"
    />
    <path
      fill="#85BDED"
      d="M30 34a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgContactKlantenservice);

export default ForwardRef;
